// @flow
import * as React from 'react';
import styled from 'styled-components';
import Plus from '../../../components/Icons/Plus';
import colors from '../../../assets/css/colors';

const ButtonContainer = styled.button`
	background:${colors.nrlGreen};
	color: ${colors.nrlDarkGreen};
	text-align: center;
	width: 50px;
	height: 50px;
	border: none;
	cursor: pointer;
	font-weight: bold;
	margin: 2px 5px;
	outline: none;
	padding: 0;
	
	&:disabled{
		background:${colors.lightGreen};
		opacity: 0.75;
		cursor: default;
	}
`;

export const DraftButton = (props: Object) => (
	<ButtonContainer {...props}>
		<Plus />
		<br />
		DRAFT
	</ButtonContainer>
);

export default DraftButton;


// WEBPACK FOOTER //
// ./src/pages/league/liveDraft/draftButton.js